/* My Place Tooltip Manager */
define(['jquery', 'c21/maps/TooltipManager'], function ($, TooltipManager) {
   "use strict";

   return function (map) {
      var self = this,
         m_map = map,
         m_jHoverTemplate = $("<div class='myPlaceMapHoverOverlay'><div class='contentTip'></div></div>"),
         m_tooltipManager = new TooltipManager(m_map, {
            hoverTemplate: m_jHoverTemplate,
            getHoverHtml: function (pinData) {
               return $.Deferred(function (dfd) {
                  //var strLid = pinData.getId(),
                  var jOnPage = $("#myPlaceMapHoverOverlay");
                  dfd.resolve(jOnPage.html());
               }).promise();
            },
            hoverOffset: {
               x: 1 + 480,
               y: -45 + 147,
               tip: 4
            },
            clickOffset: {
               x: 10 + 480,
               y: -21 + 147,
               tip: -4
            }
         }),
         initialize = function () {};

      self.showHoverTooltip = function (pinData) {
         m_jHoverTemplate.attr('class', 'myPlaceMapHoverOverlay pinHover' + pinData.getData('colorIndex'));
         return m_tooltipManager.showHoverTooltip(pinData);
      };

      self.hideHoverTooltip = m_tooltipManager.hideHoverTooltip;
      self.clear = m_tooltipManager.clear;

      initialize();
   };
});
